<style>
#addInvestmentCard .v--modal-box.v--modal {
  min-height: 360px !important;
  min-width: 600px !important;
}
#addInvestmentCard .v-tabs__div:not(:last-child) {
  padding-right: 5px;
}
#addInvestmentCard .v-select__selection {
  font-size: 12px !important;
}
#addInvestmentCard .v-subheader {
  font-size: 14px !important;
  color: #000 !important;
  font-weight: 600 !important;
}
#addInvestmentCard .v-tabs__wrapper--show-arrows {
  margin-left: 0px;
  margin-right: 0px;
}
#addInvestmentCard .caption--long {
  display: block;
  max-width: 140px;
}
.btnDisabled {
  pointer-events: none !important;
  color: rgb(136, 136, 136) !important;
}
</style>

<template>
  <Modal
    modalName="addInvestmentCard"
    :buttons="['save']"
    module="investments"
    title="DODAWANIE NOWEJ INWESTYCJI"
    @closed="close"
    @opened="getStatuses"
    @saved="addInvestment"
  >
    <div>
      <v-layout
        row
        wrap
      >
        <v-flex xs12>
          <v-subheader>ATRYBUTY INWESTYCJI</v-subheader>
        </v-flex>
      </v-layout>
      <v-layout
        row
        wrap
      >
        <v-flex xs5>
          <v-select
            :items="statuses"
            v-model="investmentData.status"
            label="Status"
          ></v-select>
        </v-flex>
        <v-spacer />
      </v-layout>

      <v-layout
        row
        wrap
      >
        <v-flex xs12>
          <v-subheader>INFORMACJE O LOKALIZACJI</v-subheader>
        </v-flex>
      </v-layout>

      <v-layout
        row
        wrap
        class="geometry-panel"
      >
        <v-flex
          xs4
          v-if="!investmentData.geometry"
          style="border-right: 1px solid lightgrey;line-height: 50px;display:flex;"
        >
          <v-icon
            class="table__btn--green geometry-panel__add-btn"
            @click="addGeometry"
          >add_circle</v-icon>
          <p
            @click="addGeometry"
            class="hover__pointer"
          >Dodaj geometrię</p>
        </v-flex>
        <v-flex
          xs4
          v-else
          style="border-right: 1px solid lightgrey;line-height: 50px;display:flex;"
        >
          <v-icon
            @click="removeGeometry"
            class="table__btn--red geometry-panel__delete-btn"
          >delete</v-icon>
          <p
            class="hover__pointer"
            @click="removeGeometry"
          >Usuń geometrię</p>
        </v-flex>
        <v-flex xs8>
          <v-layout
            justify-space-between
            id="geometry-panel"
          >
            <p
              v-if="investmentData.geometry"
              class="msg--padding"
            >Geometria dodana</p>
            <p
              v-else
              class="msg--padding"
            >Brak dodanej geometrii</p>
            <span v-if="investmentData.geometry">
              <v-icon
                title="Przybliż do geometrii"
                class="geometry-panel__zoom-btn"
                @click="zoomToInvestmentGeom"
              >zoom_in</v-icon>
            </span>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout
        row
        wrap
      >
        <v-flex xs5>
          <v-text-field
            v-model="investmentData.address_parcel"
            label="Numer działki"
          ></v-text-field>
        </v-flex>
        <v-spacer />
        <v-flex xs5>
          <v-text-field
            v-model="investmentData.address_precinct"
            label="Obręb"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout
        row
        wrap
      >
        <v-flex xs5>
          <v-text-field
            v-model="investmentData.address_place"
            label="Miejscowość"
          ></v-text-field>
        </v-flex>
        <v-spacer />
        <v-flex xs5>
          <v-text-field
            v-model="investmentData.address_street"
            label="Ulica"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout
        row
        wrap
      >
        <v-flex xs5>
          <v-text-field
            v-model="investmentData.address_order"
            label="Numer"
          ></v-text-field>
        </v-flex>
        <v-spacer />
        <v-flex xs5>
          <v-text-field
            v-model="investmentData.description"
            label="Opis"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    investmentData: {},
    isDrawing: false,
    statuses: []
  }),
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length;
    }
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  methods: {
    addGeometry() {
      this.$root.$emit(
        "showSnackbar",
        "success",
        "Kliknij na mapie, aby narysować obszar"
      );
      this.$root.$emit("addNewArea", this.objectType);
      this.isDrawing = true;
    },
    addInvestment() {
      this.$store.dispatch('addInvestment', this.investmentData).then(r => {
        if(r) {
          this.$store.dispatch('getSingleInvestment', r.data.created).then(res => {
            this.$store.commit("removeModal", 'addInvestmentCard');
            this.investmentData = {};
            this.$modal.hide('addInvestmentCard');
            this.$root.$emit('loadTab', 0);
            this.$root.$emit('loadInvestment', res);
            this.$modal.show('investmentCardModal');
            this.$root.$emit('updateInvestments')
          })
        }
        else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            `${r}`
          );
        }
      })
    },
    assignGeomToInvestment(data) {
      // this.investmentData.geom = data[0];
      this.$set(this.investmentData, 'geometry', data[0]);
    },
    close() {
      this.$root.$emit('removeMapLayer');
    },
    getStatuses() {
      let payloadStatuses = {
        schema: "investments",
        table: "investments",
        column: "status"
      }
      this.$store.dispatch('getDictSTC', payloadStatuses).then(r => {
        this.statuses = r.values;
      })
    },
    removeGeometry() {
      this.$root.$emit('removeMapLayer')
      if(this.investmentData) {
        this.investmentData.geometry = undefined;
      }
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    zoomToInvestmentGeom() {
      this.$root.$emit('zoomToArea', [this.investmentData.geometry.coordinates]);
    }
  },
  mounted() {
    this.$root.$on('newGeomAdded', this.assignGeomToInvestment);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/management/modals/AddInvestmentCard.vue